<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在保存药品加工费用设置信息...">
      <a-row :gutter="{ xs: 8, sm: 16, md: 24}">
        <a-col :xs="0" :sm="0" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="20" :sm="20" :md="18" :lg="18" :xl="18" :xxl="18">
          <a-card size="small" title="药品加工费用设置">
            <a-form :form="form" layout="horizontal">
              <a-table size="middle" :columns="columns" :scroll="{ x: '100%' }" row-key="model" :data-source="records" :pagination="false">
                  <span slot="price" slot-scope="text, record">
                    <a-form-item style="margin-bottom: 0px;">
                      <a-input-number :min="0" v-decorator="[`price${record.model}`, { rules: [{ required: true, message: '药品加工费用必须填写!' }], initialValue: record.price }]" placeholder="请填写药品加工费用"/>{{ record.unit }}
                    </a-form-item>
                  </span>
              </a-table>
            </a-form>
            <div class="button-container">
              <div>
                <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>saveUsage()">保存</a-button>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: "UsageConfig",
  data(){
    return {
      loading:false,
      current:{},
      form: this.$form.createForm(this),
      records:[],
      columns:[{
        title: '剂型',
        key: 'formName',
        dataIndex: 'formName',
        align: 'center',
        width: 150,
        customRender:(text, record, index) =>{
          return text == null || text == undefined || text == '' ? '-' : text;
        }
      },
      {
        title: '加工方式',
        key: 'modelName',
        dataIndex: 'modelName',
        width: 150,
        customRender:(text, record, index) =>{
          return text == null || text == undefined || text == '' ? '-' : text;
        }
      },
      {
        title: '收费标准',
        key: 'price',
        scopedSlots: { customRender: 'price' }
      }],
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "费用设置",
      path: ""
    },{
      text: "药品加工费用设置",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));

    this.$axios.get('/api/clinic/organ/' + this.current.organId + '/usages').then(function(res){
      if(res.msg.flag == 0 && undefined != res.biz && null != res.biz){
        res.biz.forEach(function (e) {
          e.price = e.price||0;
          self.records.push(e);
        });
      }
    },function(){
    });
  },
  methods:{
    saveUsage:function (){
      const self = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let params=[];
          self.records.forEach(function (e) {
            params.push({model:e.model, price:values['price'+e.model]});
          });
          this.loading = true;
          this.$axios.post('/api/clinic/organ/' + this.current.organId + '/usage/setting', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '药品加工费用设置保存成功', duration: 2});
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(){
            self.loading = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
